module.exports = __webpack_public_path__ + "img/logo.01f1829b.svg";